export const VERIFICATION_TEST = `
# Test Verification

- Run targeted tests for changed behavior before broader suites.
- Add or update regression tests when the change fixes a bug or guards a public contract.
- Report pass, fail, or skipped status with exact command evidence.
`;
